import {React, useState, useEffect} from 'react';
import '../../App.css'
import axios from 'axios';
import { Grid, TextField, Box, Button, Paper, Stack, Typography} from '@mui/material';
import {PriceCheck, RestartAlt, ArrowForwardIos,} from '@mui/icons-material';
import * as employeeService from '../../services/employeeService';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import Popup from '../Popup';
import DataTable from '../DataTable';

// Custom component for required field label
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px' }}>*</span>
  </span>
);

const options = employeeService.getDepartmentCollection();

let noOfRows = 0;

const initialFValues={
  id: 0,
  ptGrossSalLimitAmount: '',
  ptFrom: '',
  ptTo: '',
  ptAmount: '',
  ptAbove: '',
  ptAboveAmountN: '',
  ptAboveAmountF: '',
  pfBasicSalLimit: '',
  pfPercent: '',
  basicSal: '',
  hraPercent: '',
  conveyancePercent: '',
  ltaPercent: '',
  medicalPercent: '',
  bonusPercent: '',
  pfAllowancePercent: '',
}

function SalaryParametersForm(){

  const validate = () => {
    let temp = {}
    temp.ptGrossSalLimitAmount = values.ptGrossSalLimitAmount ? "" : "This field is required."
    temp.ptFrom = values.ptFrom ? "" : "This field is required."
    temp.ptTo = values.ptTo ? "" : "This field is required."
    temp.ptAmount = values.ptAmount ? "" : "This field is required."
    temp.ptAbove = values.ptAbove ? "" : "This field is required."
    temp.ptAboveAmountN = values.ptAboveAmountN ? "" : "This field is required."
    temp.ptAboveAmountF = values.ptAboveAmountF ? "" : "This field is required."
    temp.pfBasicSalLimit = values.pfBasicSalLimit ? "" : "This field is required."
    temp.pfPercent = values.pfPercent ? "" : "This field is required."
    temp.basicSal = values.basicSal ? "" : "This field is required."
    temp.hraPercent = values.hraPercent ? "" : "This field is required."
    temp.conveyancePercent = values.conveyancePercent ? "" : "This field is required."
    temp.ltaPercent = values.ltaPercent ? "" : "This field is required."
    temp.medicalPercent = values.medicalPercent ? "" : "This field is required."
    temp.bonusPercent = values.bonusPercent ? "" : "This field is required."
    temp.pfAllowancePercent = values.pfAllowancePercent ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [salaryParameters, setSalaryParameters] = useState({});

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    });

    if (errors[name]){
      setErrors({
        ...errors,
        [name]: ''
      });
    } 
    
  }

  useEffect(() => {
    async function getSalaryParameter(){
      try{
        const salaryParameters = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/salary-parameter/get`);
        setSalaryParameters(salaryParameters.data[0]);
        noOfRows = salaryParameters.data.length;

        const editFValues = {
          ptGrossSalLimitAmount: salaryParameters.data[0].pt_gs_limit_amount,
          ptFrom: salaryParameters.data[0].pt_gs_between_amount_from,
          ptTo: salaryParameters.data[0].pt_gs_between_amount_to,
          ptAmount: salaryParameters.data[0].pt_between_amount,
          ptAbove: salaryParameters.data[0].pt_above,
          ptAboveAmountN: salaryParameters.data[0].pt_above_amount,
          ptAboveAmountF: salaryParameters.data[0].pt_above_in_feb,
          pfBasicSalLimit: salaryParameters.data[0].pf_bs_limit,
          pfPercent: salaryParameters.data[0].pfund,
          basicSal: salaryParameters.data[0].BSalDiv,
          hraPercent: salaryParameters.data[0].HRAPercentage,
          conveyancePercent: salaryParameters.data[0].ConveyancePercentage,
          ltaPercent: salaryParameters.data[0].LTAPercentage,
          medicalPercent: salaryParameters.data[0].MedicalPercentage,
          bonusPercent: salaryParameters.data[0].BonusPercentage,
          pfAllowancePercent: salaryParameters.data[0].PFAllowance,
        }

        setSalaryParameters(salaryParameters);

        if(noOfRows === 0) {
          setValues(initialFValues);
        }else {
          setValues(editFValues);
        }

      }catch(e){
      }
    }
    getSalaryParameter();
  },[]);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/company-master/salary-parameter/save/`+noOfRows, values)
      .then(function (response) {
      })
      .catch(function (error) {
      });
    if(validate())
      window.location.reload();
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", padding: "30px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "1000px"}}>
        <Grid className="form-title" style={{marginBottom: "-4px"}} container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>SALARY PARAMETERS</Typography> </Grid>
          <Grid item> <HiOutlineCurrencyRupee style={{marginLeft: "-30px"}} size={40} sx={{height:45,width:45}}/> </Grid>
        </Grid>
        <p style={{color: 'red',marginLeft: '55px',fontSize: '12px', marginTop: '10px'}}> Note : All Fields are Mandatory </p>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack>

            <Stack direction="row" className= "space-around">
                <Stack sx={{width: "400px", margin: "20px"}} spacing={3}>
                    <TextField
                      variant="outlined"
                      name="ptGrossSalLimitAmount"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax Gross Salary Limit Amount" />}
                      value={values.ptGrossSalLimitAmount}
                      onChange={handleInputChange}
                      {...(errors.ptGrossSalLimitAmount && {error:true, helperText: errors.ptGrossSalLimitAmount} )}
                    />
                    <TextField
                      variant="outlined"
                      name="ptFrom"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax From" />}
                      value={values.ptFrom}
                      onChange={handleInputChange}
                      {...(errors.ptFrom && {error:true, helperText: errors.ptFrom} )}
                    />
                    <TextField
                      variant="outlined"
                      name="ptTo"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax To" />}
                      value={values.ptTo}
                      onChange={handleInputChange}
                      {...(errors.ptTo && {error:true, helperText: errors.ptTo} )}
                    />
                    <TextField
                      variant="outlined"
                      name="ptAmount"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax Amount" />}
                      value={values.ptAmount}
                      onChange={handleInputChange}
                      {...(errors.ptAmount && {error:true, helperText: errors.ptAmount} )}
                    />

                    <TextField
                      variant="outlined"
                      name="ptAbove"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax Above (Normal)" />}
                      value={values.ptAbove}
                      onChange={handleInputChange}
                      {...(errors.ptAbove && {error:true, helperText: errors.ptAbove} )}
                    />
                    <TextField
                      variant="outlined"
                      name="ptAboveAmountN"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax Above (Normal)" />}
                      value={values.ptAboveAmountN}
                      onChange={handleInputChange}
                      {...(errors.ptAboveAmountN && {error:true, helperText: errors.ptAboveAmountN} )}
                    />

                    <TextField
                      variant="outlined"
                      name="ptAboveAmountF"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Professional Tax Above (In February)" />}
                      value={values.ptAboveAmountF}
                      onChange={handleInputChange}
                      {...(errors.ptAboveAmountF && {error:true, helperText: errors.ptAboveAmountF} )}
                    />
                    <TextField
                      variant="outlined"
                      name="pfBasicSalLimit"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Provident Fund Basic Salary Limit" />}
                      value={values.pfBasicSalLimit}
                      onChange={handleInputChange}
                      {...(errors.pfBasicSalLimit && {error:true, helperText: errors.pfBasicSalLimit} )}
                    />
                </Stack>

                <Stack sx={{width: "400px", margin: "20px"}} spacing={3}>

                    <TextField
                      variant="outlined"
                      name="pfPercent"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Provident Fund (%)" />}
                      value={values.pfPercent}
                      onChange={handleInputChange}
                      {...(errors.pfPercent && {error:true, helperText: errors.pfPercent} )}
                    />
                    <TextField
                      variant="outlined"
                      name="basicSal"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="Basic Salary = CTC / " />}
                      value={values.basicSal}
                      onChange={handleInputChange}
                      {...(errors.basicSal && {error:true, helperText: errors.basicSal} )}
                    />
                    <TextField
                      variant="outlined"
                      name="hraPercent"
                      id="outlined-basic"
                      size="small"
                      label={<RequiredLabel label="H.R.A (%)" />}
                      value={values.hraPercent}
                      onChange={handleInputChange}
                      {...(errors.hraPercent && {error:true, helperText: errors.hraPercent} )}
                    />
                    <TextField
                      variant="outlined"
                      name="conveyancePercent"
                      label={<RequiredLabel label="Conveyance (%)" />}
                      size="small"
                      value={values.conveyancePercent}
                      onChange={handleInputChange}
                      {...(errors.conveyancePercent && {error:true, helperText: errors.conveyancePercent} )}
                    />
                    <TextField
                      variant="outlined"
                      name="ltaPercent"
                      label={<RequiredLabel label="L.T.A (%)" />}
                      size="small"
                      value={values.ltaPercent}
                      onChange={handleInputChange}
                      {...(errors.ltaPercent && {error:true, helperText: errors.ltaPercent} )}
                    />
                    <TextField
                      variant="outlined"
                      name="medicalPercent"
                      label={<RequiredLabel label="Medical (%)" />}
                      size="small"
                      value={values.medicalPercent}
                      onChange={handleInputChange}
                      {...(errors.medicalPercent && {error:true, helperText: errors.medicalPercent} )}
                    />
                    <TextField
                      variant="outlined"
                      name="bonusPercent"
                      label={<RequiredLabel label="Bonus (%)" />}
                      size="small"
                      value={values.bonusPercent}
                      onChange={handleInputChange}
                      {...(errors.bonusPercent && {error:true, helperText: errors.bonusPercent} )}
                    />

                    <TextField
                    variant="outlined"
                    name="pfAllowancePercent"
                    label={<RequiredLabel label="PF Allowance (%)" />}
                    size="small"
                    value={values.pfAllowancePercent}
                    onChange={handleInputChange}
                    {...(errors.pfAllowancePercent && {error:true, helperText: errors.pfAllowancePercent} )}
                    />
                </Stack>
          </Stack>
          <Grid container className="form-btn-container">
              <Grid item>
              <Button className="form-btn" variant="contained" color="error" disableElevation onClick={resetForm} endIcon={<RestartAlt />} >Reset</Button>
              </Grid>
              <Grid item>
              <Button className="form-btn" variant="contained" color="success" disableElevation type="submit" endIcon={<ArrowForwardIos sx={{width: "18px", height: "18px"}} />} >Submit</Button>
              </Grid>
            </Grid>

          </Stack>
        </form>

        <Popup
        title="Employee Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <DataTable/>
        </Popup>


      </Paper>
    </Box>
  )
}

export default SalaryParametersForm;
